import { useEffect } from 'react';
import { useAssessmentsOverviewContext } from '../Contexts/AssessmentsOverviewContext';
import AssessmentsOverviewList from './AssessmentsOverviewList';
import { AssessmentStatuses } from '@/Models/AssessmentData';

function ClosedAssessmentsOverviewList() {
    const { filterByStatus } = useAssessmentsOverviewContext();
    useEffect(() => {
        filterByStatus(AssessmentStatuses.Closed);
    }, []);

    return <AssessmentsOverviewList />;
}

export default ClosedAssessmentsOverviewList;
